import axiosRagflow from 'constants/axios';
import * as DocumentList from 'containers/desktop/KnowledgeBases/types/DocumentList';
import * as KnowledgeBase from 'containers/desktop/KnowledgeBases/types/KnowledgeBase';

export type Type = KnowledgeBase.Type[];

export function create(): Type {
	return [];
}

export async function initialize(): Promise<Type> {
	const list = await getAllFromApi();
	const output = [];
	for (const item of list) {
		output.push({
			id: item.id,
			name: item.name,
			documents: await DocumentList.getAllFromApi(item.id),
		});
	}
	return output;
}

export async function getAllFromApi(): Promise<Type> {
	const response = await axiosRagflow.get(`/api/v1/datasets`, {
		params: {},
	});
	if (!response) return create();
	if (!response?.data?.data) return create();
	if (!response?.data?.data?.length) return create();
	return response?.data?.data?.map((item: any) => ({
		id: item?.id ?? '',
		name: item?.name ?? '',
	}));
}
